<a class="seg-flex-align-center" [ngClass]="variant()" [href]="url()" id="back-to-somfypro">
  <img class="somfy-logo" src="assets/img/app-somfy-logo-yellow.svg" />
  <span class="pro">PRO</span>
</a>
